module.exports = __webpack_public_path__ + "static/media/platform_section_deals.dfe49053.webp";